var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c(
      "div",
      { staticClass: "tab-button" },
      [
        _c(
          "div",
          {
            staticClass: "tab",
            class: { active: _vm.active === 0 },
            on: {
              click: function () {
                _vm.active = 0
              },
            },
          },
          [_vm._v("公告")]
        ),
        _c(
          "div",
          {
            staticClass: "tab",
            class: { active: _vm.active === 1 },
            on: {
              click: function () {
                _vm.active = 1
              },
            },
          },
          [_vm._v("文件下载")]
        ),
        _c(
          "el-button",
          {
            staticClass: "btn",
            attrs: { type: "primary", icon: "el-icon-video-camera-solid" },
            on: { click: _vm.toVideoExplain },
          },
          [_vm._v("视频讲解")]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tab-content" },
      [
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "notices-item",
              on: {
                click: function ($event) {
                  return _vm.itemClick(item, index)
                },
              },
            },
            [
              _c("div", { staticClass: "des" }, [_vm._v(_vm._s(item.title))]),
              _c("div", { staticClass: "time" }, [_vm._v(_vm._s(item.time))]),
            ]
          )
        }),
        !_vm.list.length
          ? _c("div", { staticClass: "empty" }, [
              _c("img", {
                attrs: { src: require("../../assets/empty.png"), alt: "" },
              }),
              _c("div", [_vm._v("暂无内容")]),
            ])
          : _vm._e(),
      ],
      2
    ),
    _c("div", { staticClass: "footer" }, [
      _vm._v(
        " 技术支持：中联集团教育科技有限公司 | 联系人： 任老师 18810991825 或（010）88000385 | 本平台仅用于模拟练习使用 "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }